import { render, staticRenderFns } from "./ResourceCenter.vue?vue&type=template&id=65fc6342&scoped=true"
import script from "./ResourceCenter.vue?vue&type=script&lang=js"
export * from "./ResourceCenter.vue?vue&type=script&lang=js"
import style0 from "./ResourceCenter.vue?vue&type=style&index=0&id=65fc6342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc6342",
  null
  
)

export default component.exports